export const getStaticPricing = (currency: string) => {
    const pricingMap: Record<'INR' | 'USD', { current: number; original: number }> = {
      INR: { current: 199, original: 99 },
      USD: { current: 2, original: 10 },
    };
    
    return pricingMap[currency as 'INR' | 'USD'] || pricingMap['USD']; // default fallback
  };

  export const getStaticPricingBundle = (currency: string) => {
    const pricingMap: Record<'INR' | 'USD', { current: number; original: number }> = {
      INR: { current: 399, original: 199 },
      USD: { current: 4, original: 25},
    };
    
    return pricingMap[currency as 'INR' | 'USD'] || pricingMap['USD']; // default fallback
  };
  